// Frontend mirror of Web-Interviewer/utils/permissions.py (T2-1 / T2-1b).
// Used only to drive nav visibility — the backend is the real authority.

export const ROLE_PERMISSIONS = {
  super_admin: ['*'],
  admin: [
    'companies.read', 'companies.write', 'companies.delete',
    'jobs.read', 'jobs.write',
    'candidates.read', 'candidates.write',
    'audit.read',
  ],
  billing_admin: ['credits.read', 'credits.write', 'companies.read', 'audit.read'],
  viewer: ['*.read'],
};

export function hasPermission(role, needed) {
  const perms = ROLE_PERMISSIONS[role] || [];
  for (const p of perms) {
    if (p === '*' || p === needed) return true;
    if (p.endsWith('.*') && needed.startsWith(p.slice(0, -1))) return true; // 'credits.*'
    if (p.startsWith('*.') && needed.endsWith(p.slice(1))) return true;      // '*.read'
  }
  return false;
}
